import styled, { css } from 'styled-components';

import UI from '../../common/UI';

interface PagerContainerProps {
  isSticky: boolean;
  isEmbedded: boolean;
  isExpanded?: boolean;
  right: number | string;
  bottom: number | string;
  left: number | string;
}

const PagerContainer = styled(UI.Div)<PagerContainerProps>`
  ${({ isSticky, isEmbedded, isExpanded = false, right, bottom, left, theme }) => css`
    ${!isSticky && css`
      border-bottom-left-radius: ${theme.borderRadiuses['2xl']}px;
      border-bottom-right-radius: ${theme.borderRadiuses['2xl']}px;
    `}

    ${isEmbedded && css`
      @media ${theme.devices.md} {
        border-bottom-left-radius: ${theme.borderRadiuses['2xl']}px;
        border-bottom-right-radius: ${theme.borderRadiuses['2xl']}px;
      }
    `}

    > ${UI.Div} {
      padding: ${theme.gutter * 0.75}px;

      @media ${theme.devices.md} {
        padding-left: ${theme.gutter}px;
        padding-right: ${theme.gutter}px;

        ${isEmbedded && css`
          border-bottom-left-radius: ${theme.borderRadiuses.lg}px;
          border-bottom-right-radius: ${theme.borderRadiuses.lg}px;
        `}
      }
    }

    ${isSticky && css`
      position: fixed;
      right: ${right}px;
      bottom: ${bottom}px;
      left: ${left}px;
      z-index: 400;
      background: ${theme.transparentize(theme.colors.gray[50], 0.1)};
      ${!isExpanded && css`
        background: linear-gradient(0deg, ${theme.colors.gray[75]} 0%, ${theme.transparentize(theme.colors.gray[50], 0.1)} 60%, ${theme.transparentize(theme.colors.gray[50], 0.4)} 100%);
      `}
      ${isExpanded && css`
        background: linear-gradient(0deg, ${theme.colors.gray[75]} 0%, ${theme.transparentize(theme.colors.gray[50], 0.1)} 60%, ${theme.transparentize(theme.colors.gray[50], 0.2)} 100%);
      `}
      backdrop-filter: blur(3px);
      border-top: 1px solid rgba(0, 0, 0, 0.08);
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0 1px 0 rgba(255, 255, 255, 0.5);

      > ${UI.Div} {
        padding-left: ${theme.gutter * (17 / 12)}px;
        padding-right: ${theme.gutter * (17 / 12)}px;

        @media ${theme.devices.md} {
          padding-left: ${theme.gutter * 2.5}px;
          padding-right: ${theme.gutter * 2.5}px;
          max-width: ${theme.breakpoints.md}px;
          margin: 0 auto;
        }
      }
    `}
  `}
`;

export default PagerContainer;
